import { acceptTermsAndConditionsRequest } from '../../utils/user'
import { logError } from '../../utils/errors'
import { showAlert } from '../common'

/**
 * Get user profile actions
 */
export const getUserRequestAction = () => ({ type: 'getUserRequest' })
export const getUserSuccessAction = user => ({
  type: 'getUserSuccess',
  payload: user
})
export const getUserFailureAction = () => ({ type: 'getUserFailure' })

export const getGuestUserAction = () => ({
  type: 'getGuestUser'
})

export const acceptCurrentTermsAndConditions = (value = true) => ({
  type: 'acceptCurrentTermsAndConditions',
  payload: value
})

export const setAcceptCurrentTermsAndConditions = () => (
  dispatch,
  getState
) => {
  const jwtToken = getState().user.token
  dispatch(acceptCurrentTermsAndConditions())
  return acceptTermsAndConditionsRequest(jwtToken)
    .catch(err => Promise.reject(logError(err)))
    .catch(() => {
      dispatch(
        showAlert(
          "Accepting terms and conditions was unsuccessful. Please try again later or contact our <a href='https://help.market.envato.com/hc/en-us/requests/new'>Help Team</a>."
        )
      )
      dispatch(acceptCurrentTermsAndConditions(false))
    })
}
